import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography } from "@mui/material";
import { SearchBox } from "./";
import * as actions from "../../api/actions/pos";
import { connect } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const Products = (props) => {
  const { t } = useTranslation();
  const { _inventoryList, setCartItems, _store } = props;
  const prodCls = {
    borderTopLeftRadius: "0.8rem",
    borderTopRightRadius: "0.8rem",
    height: "150px",
    width: "100%",
    objectFit: "cover",
    borderBottom: "1px solid var(--grayLight-color)",
  };

    const handleCart = (prod) => {
      // ✅ protect against bad object
      if (!prod || !prod.product || !prod.product.id) {
        console.log("Invalid product:", prod);
        return;
      }

      setCartItems((items) => {
        const existing = items.find(
          (j) => j.productId === prod.product.id
        );

        // ✅ no stock
        if (Number(prod.inInventory) <= 0) return items;

        // ✅ add new
        if (!existing) {
          return [
            {
              productId: prod.product.id,
              name: prod.product.name,
              price: prod.product.sellPrice,
              tax: prod.product.tax,
              qty: 1,
              itemType: 1,
            },
            ...items,
          ];
        }

        // ✅ increase qty
        if (Number(prod.inInventory) > existing.qty) {
          return items.map((j) =>
            j.productId === prod.product.id
              ? { ...j, qty: parseInt(j.qty) + 1 }
              : j
          );
        }

        return items;
      });
    };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchBox type="product" handleCart={handleCart} />
      </Grid>
      {_inventoryList?.length > 0 &&
        //_list.map((inv, i) => (
        _inventoryList
          .filter((inv) => inv?.product)
          .map((inv, i) => (
          <Grid item xs={6} sm={3} xl={2} key={i}>
            <Paper
              onClick={() => handleCart(inv)}
              className="br-8 shadow-xs c-pointer"
            >
              <img
                style={prodCls}
                className="img-fluid"
                src={
                  inv?.product?.imgs?.length > 0
                   ? inv?.product?.imgs?.[0]?.imgUrl
                    : `${process.env.PUBLIC_URL}/assets/no-pictures.png`
                }
                alt="prod-img"
              />
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "12px" }}
                className="p-5 gray-color"
              >
                {inv?.product?.name}
                <div className="d-block">
                  <span className="fs-12 fw-6">
                    {t("price")}: {formatCurrency(inv?.product?.sellPrice, _store)}
                  </span>

                  &nbsp;||&nbsp;
                  
                  <span
                    className={`fs-12 fw-6 ${
                      inv.inInventory <= 0 && " error-color"
                    }`}
                  >
                    {t("inStore")}: {inv.inInventory}
                  </span>
                </div>
              </Typography>
            </Paper>
          </Grid>
        ))}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  _inventoryList: state.pos.inventoryList,
  _authUser: state.pos.authUser,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _setVal: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(Products);
